import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError, notifySuccess} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import dashboard7 from '../locales/dashboard7.json';
import {DatePicker, Label} from '../../../common/components/form';
import {IconLink} from "../../../common/components/link";
import VSelect from "../../../common/components/form/VSelect";
import {formatDate} from "../../../helpers/utils";

class DashboardBox7 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			businessUnitsList: [],
			typesList: [],
			statusesList: [],
			andons: [],
			searchForm: {
				type: '',
				status: '',
				business_unit_id: '',
				start_date: '',
				end_date: ''
			}
		}
	}

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard7);
		this.loadDashboard();
		const {searchForm} = this.state;
		this.loadDashboardSearchFormSubmit(searchForm);
	}

	updateSearchFormState = (object) => {
		const searchForm = {
			...this.state.searchForm,
			...object
		};
		this.setState({searchForm: searchForm});

		this.loadDashboardSearchFormSubmit(searchForm);
	};

	loadDashboard = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/7`);

			const businessUnitsList = response.data.business_units.map(item => ({
				value: item.id,
				label: item.code + ' - ' + item.name
			}));

			const typesList = response.data.types.map(item => ({
				value: item,
				label: item
			}));

			const statusesList = response.data.statuses.map(item => ({
				value: item,
				label: item
			}));

			this.setState({
			    isLoading: false,
			    businessUnitsList: businessUnitsList,
				typesList: typesList,
				statusesList: statusesList
            });
		} catch (error) {
			notifyError(error.message);
		}
	};

	loadDashboardSearchFormSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		this.setState({isLoading: true});
		try {
			const formData = Object.assign({}, values);
			formData.start_date = formData.start_date ? formData.start_date.format('YYYY-MM-DD') : '';
			formData.end_date = formData.end_date ? formData.end_date.format('YYYY-MM-DD') : '';

			const response = await api.post('/dashboard/7/search', formData);
			notifySuccess(response.message);

			const andons = response.data.andons;

			this.setState({isLoading: false,  andons: andons});
		} catch (error) {
			this.setState({isLoading: false});
			notifyError(error.message);
		}
	};

	isBeforeEndDate = (current) => {
		const {searchForm} = this.state;
		if(searchForm.end_date === '') {
			return true;
		}
		return current.isSameOrBefore(searchForm.end_date);
	};

	isAfterStartDate = (current) => {
		const {searchForm} = this.state;
		if(searchForm.start_date === '') {
			return true;
		}
		return current.isSameOrAfter(searchForm.start_date);
	};

	render() {
		const {translate} = this.props;
		const {businessUnitsList, typesList, statusesList, searchForm, andons} = this.state;

		const content = (
			<div className="content-wrapper">
				<section className="content">
					<div className="box">
						<div className="box-body with-top-padding">
							<div className="row">
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_search_form_type')}/>
										<VSelect list={typesList} clearable={true} value={searchForm.type} onChange={selected => this.updateSearchFormState({type: selected || ''})}/>
									</div>
								</div>

								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_search_form_status')}/>
										<VSelect list={statusesList} clearable={true} value={searchForm.status} onChange={selected => this.updateSearchFormState({status: selected || ''})}/>
									</div>
								</div>

								<div className="col-md-4">
									<div className="form-group">
										<Label text={translate('dashboard_page_search_form_business_unit_id')}/>
										<VSelect multi={true} list={businessUnitsList} clearable={true} value={searchForm.business_unit_id} onChange={selected => this.updateSearchFormState({business_unit_id: selected || ''})}/>
									</div>
								</div>

								<div className="col-sm-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_search_form_start_date')} />
										<DatePicker isValidDate={this.isBeforeEndDate} value={searchForm.start_date ? formatDate(searchForm.start_date) : ''} onChange={date => {this.updateSearchFormState({start_date: date})}} />
									</div>
								</div>

								<div className="col-sm-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_search_form_end_date')} />
										<DatePicker isValidDate={this.isAfterStartDate} value={searchForm.end_date ? formatDate(searchForm.end_date) : ''} onChange={date => this.updateSearchFormState({end_date: date})} />
									</div>
								</div>
							</div>
						</div>
					</div>

					{
						(andons.length > 0) && andons.map((andon, index) => (
							<div className="info-box info-box-icon-left" key={`dashboard_page_box_${index}`}>
								<span className="info-box-icon bg-green">
									<p style={{fontSize: '16px'}}>{andon.status}</p>
								</span>
								<div className="info-box-content" style={{paddingBottom: "0"}}>
									<div className="row">
										<div className="col-md-1">
											<span className="info-box-text">Number</span>
											<span className="info-box-number">
												<IconLink type="link" to={`/andons/${andon.id}`} text={andon.number}/>
											</span>
										</div>
										<div className="col-md-2">
											<span className="info-box-text">Name</span>
											<span className="info-box-number" style={{maxHeight: "50px", overflow: "scroll"}}>{andon.name}</span>
										</div>
										<div className="col-md-1">
											<span className="info-box-text">Type</span>
											<span className="info-box-number">{andon.type}</span>
										</div>
										<div className="col-md-2">
											<span className="info-box-text">Time Opened</span>
											<span className="info-box-number">{formatDate(andon.created_at, 'MMM DD, YYYY HH:mm:ss')}</span>
										</div>
										<div className="col-md-2">
											<span className="info-box-text">Time Closed</span>
											<span className="info-box-number">{andon.resolved_at ? formatDate(andon.resolved_at, 'MMM DD, YYYY HH:mm:ss') : ''}</span>
										</div>
										<div className="col-md-3">
											<span className="info-box-text">Resolution Note</span>
											<span className="info-box-number" style={{maxHeight: "50px", overflow: "scroll"}}>{andon.ResolvedNote ? andon.ResolvedNote.note : ''}</span>
										</div>
									</div>

								</div>
							</div>
						))
					}
				</section>

			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError,
	notifySuccess
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox7);
